export default {"src":"/_next/static/media/ARB.9e466bf7.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};